import SortBy from "../SortBy";
import { useParams } from "react-router-dom";

import useCloudPermissions from "../../../../hooks/useCloudPermissions";
import useWorkspacePermissions from "../../../../hooks/useWorkspacePermissions";
import usePagePermissions from "../../../../hooks/usePagePermissions";
import useUpdateView from "../../../../api/api-hooks/views/useUpdateView";
import { View } from "../../../../types/PageInterfaces";

interface Props {
  query: any;
  updateSortBy: any;
  view: View;
  parentViewID?: string;
}

const SharedSortBy = ({ query, updateSortBy, view, parentViewID }: Props) => {
  const { pageID }: any = useParams();
  const { cPermissions } = useCloudPermissions();
  const { wPermissions } = useWorkspacePermissions();
  const { pPermissions } = usePagePermissions(pageID);
  const { updateView } = useUpdateView(pageID);

  function onSortBySave() {
    // @ts-ignore
    updateView({
      parentViewID,
      viewID: view?.id as string,
      payload: { Query: { ...query, _SelectedOrderBy: query.OrderBy } },
      onSuccess: () => {
        // TODO: toast here
      },
    });
  }

  return (
    // @ts-ignore
    <SortBy
      savedSortBy={view?.Query?._SelectedOrderBy}
      sortBy={query?.OrderBy}
      updateSortBy={updateSortBy}
      moduleAPIName={view?.ModuleAPIName}
      onSave={
        cPermissions.cloud_modify_page ||
        wPermissions.workspace_modify_page ||
        pPermissions.page_modify_page
          ? onSortBySave
          : undefined
      }
    />
  );
};

export default SharedSortBy;
